import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { getAllLocation, getAllTransferLocation } from "../../actions/warehouseAction";
import { DeleteOutlined } from "@ant-design/icons";
import { createTransfer, createTransferItem } from "../../actions/transfer";
import { updateVariation } from "../../actions/variableProductAction";
// import history from "../../history";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Skeleton,
  TreeSelect,
  Form,
  Affix,
  InputNumber,
  Button,
  Modal,
  Input,
  message,
} from "antd";
import AddtoTransfer from "./AddtoTransfer";
import { verifyPin } from "../../actions/authAction";
import { useNavigate } from "react-router-dom";

const SearchStock = ({
  Auth,
  getAllLocation,
  getAllTransferLocation,
  createTransfer,
  createTransferItem,
  updateVariation,
  verifyPin,
}) => {
  const navigate = useNavigate();
  const [Loactions, setLoaction] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [refresh, setrefresh] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submit button
  const [isPinVerified, setIsPinVerified] = useState(false);
  const [pinModalVisible, setPinModalVisible] = useState(true);
  const [pin, setPin] = useState("");
  const [verifying, setVerifying] = useState(false);
  const To = useRef("");
  const From = useRef(Auth.profile.Office);
  const cartItems = useRef([]);
  var currentdate = new Date();
  var invoiceNumber =
    currentdate.getDate().toString() +
    (currentdate.getMonth() + 1).toString() +
    currentdate.getFullYear().toString() +
    currentdate.getHours().toString() +
    currentdate.getMinutes().toString() +
    currentdate.getSeconds().toString();
  useEffect(() => {
    setrefresh(false);
    console.log(cartItems);
    setLoading(false);
    calculateTotalQuantity()
  }, [refresh]);

  const calculateTotalQuantity = () => {
    const total = cartItems.current.reduce((sum, item) => sum + item.quantity, 0);
    setTotalQuantity(total);
  };

  const handlePinVerify = async () => {
    setVerifying(true);
    const result = await verifyPin(pin, Auth.token);
    setVerifying(false);
    if (result.success) {
      setIsPinVerified(true);
      setPinModalVisible(false);
      message.success("PIN verified successfully");
    } else {
      message.error(result.message || "Invalid PIN");
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    getAllTransferLocation().then((result) => {
      // getAllLocation().then((result) => {
      setLoaction(result);
      setLoading(false);
    });
  }, []);

  if (Loading) {
    return <Skeleton active />;
  }

  return (
    <>
      <Modal
        title="Enter Security PIN"
        visible={pinModalVisible}
        onOk={handlePinVerify}
        onCancel={() => navigate("/dashboard")}
        confirmLoading={verifying}
        maskClosable={false}
        closable={false}
      >
        <p>Please enter your 6-digit PIN to access Stock Transfer.</p>
        <Input.Password
          placeholder="Enter PIN"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          onPressEnter={handlePinVerify}
          maxLength={6}
        />
      </Modal>

      {isPinVerified && (
        <Row>
          <Col span={12} style={{ paddingTop: "10px", paddingRight: "10px" }}>
            <Affix>
              <AddtoTransfer
                cartItems={cartItems}
                setrefresh={setrefresh}
                setLoading={setLoading}
                from={From}
                Loactions={Loactions}
              />
            </Affix>
          </Col>

          <Col
            span={12}
            style={{
              padding: "30px",
              paddingTop: "10px",
              backgroundColor: "whitesmoke",
              borderRadius: "10px",
              minHeight: "85vh",
            }}
          >
            <Row>
              <Col style={{ width: "100%" }}>
                <Form.Item name="Merchandiser" label="To">
                  <TreeSelect
                    treeData={Loactions}
                    onChange={(value) => {
                      To.current = value;
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="Item-list-header" style={{ textAlign: "center" }}>
              <Col span={1}>
                <h3>SL.</h3>
              </Col>
              <Col span={10}>
                <h3>Product</h3>
              </Col>
              <Col span={6}>
                <h3>Details</h3>
              </Col>
              <Col span={4}>
                <h3>Quantity</h3>
              </Col>
              <Col span={3}>
                <h3>Action</h3>
              </Col>
            </Row>
            {cartItems.current.map((item, index) => {
              console.log("=======================", item, "=======================")
              return (
                <Row className="Item-list" style={{ textAlign: "center" }}>
                  <Col span={1}>{index + 1}</Col>
                  <Col span={10}>{item.product_code}//{item.title}</Col>
                  <Col span={6}>
                    Attribute: {item.color}  {item.size}
                  </Col>
                  <Col span={4}>{item.quantity}</Col>
                  <Col span={3}>
                    <DeleteOutlined
                      style={{ color: "Red" }}
                      onClick={(e) => {
                        cartItems.current.splice(index, 1);
                        calculateTotalQuantity();
                        setrefresh(true);
                      }}
                    />
                  </Col>
                </Row>
              );
            })}

            <Divider />

            {/* Display the total quantity */}
            <Row style={{ textAlign: "center", marginBottom: "20px" }}>
              <Col span={24}>
                <h3>Total Quantity: {totalQuantity}</h3>
              </Col>
            </Row>

            <Button
              type="primary"
              disabled={isSubmitting} // Disable button when submitting
              loading={isSubmitting}  // Show loading spinner when submitting
              onClick={(e) => {
                let promises = [];
                if (From.current == "" || To.current == "") {
                  alert("Please insert all the required fields");
                } else {
                  setIsSubmitting(true); // Disable the button
                  let formData = new FormData();
                  formData.append("tansfer_number", invoiceNumber);
                  formData.append("status", "Processing");
                  formData.append("source", From.current);
                  formData.append("destance", To.current);
                  formData.append("trasnfer_by", Auth.profile.name);
                  formData.append("data", "");
                  createTransfer(formData).then((result) => {
                    for (const item of cartItems.current) {
                      formData = new FormData();
                      formData.append("transfer", result.id);
                      formData.append("product", item.id);
                      formData.append("quantity", item.quantity);
                      formData.append("is_received", false);
                      formData.append("data", "");
                      promises.push(createTransferItem(formData));
                      formData = new FormData();
                      formData.append("quantity", item.limit - item.quantity);
                      formData.append("data", "");
                      // promises.push(updateVariation(item.id, formData));
                    }
                    // history.push("/stock/transfer/history");
                    Promise.all(promises).then((e) => {
                      window.location.href = "/stock/transfer/history";
                    }).catch((error) => {
                      // Handle error and re-enable button if needed
                      console.error("Error during submission:", error);
                      setIsSubmitting(false);
                    });
                  }).catch((error) => {
                    // Handle error and re-enable button if needed
                    console.error("Error creating transfer:", error);
                    setIsSubmitting(false);
                  });
                }
              }}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getAllLocation,
  getAllTransferLocation,
  createTransfer,
  createTransferItem,
  updateVariation,
  verifyPin,
})(SearchStock);